import { baseURL } from "../utils/url";


export const getVoucher = async ( merchantCode) => {
    try {
        const fetchResponse = await fetch(baseURL + `GetVoucherTemplate?merchantCode=${merchantCode}`, {
            method: "GET",
            headers: {
              
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};



export const getAllGiftCard = async ( clientId) => {
    try {
        const fetchResponse = await fetch(baseURL + `GetGiftCard`, {
            method: "GET",
            headers: {
              
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};
export const getGiftCard = async ( clientId) => {
    try {
        const fetchResponse = await fetch(baseURL + `GetGiftCardFoMerchant?clientId=${clientId}`, {
            method: "GET",
            headers: {
              
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const deleteGiftCard = async (clientId,body) => {
    try {
        const fetchResponse = await fetch(baseURL + `DeleteGiftCardForMerchant?clientId=${clientId}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};
export const postGiftCard = async (body) => {
    try {
        const fetchResponse = await fetch(baseURL + "PostGiftCardFoMerchant", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};
export const createVoucher = async (body) => {
    try {
        const fetchResponse = await fetch(baseURL + "PostVoucherTemplate", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};
export const getVoucherByid = async (merchantCode,voucherTemplateCode) => {
    try {
        const fetchResponse = await fetch(baseURL + `GetVoucherTemplatebyCode?merchantCode=${merchantCode}&voucherTemplateCode=${voucherTemplateCode}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
            
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const generateVoucher = async (voucherType, merchantCode,voucherTemplateCode,file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const fetchResponse = await fetch(
      baseURL + `GenerateVoucher?voucherType=${voucherType}&merchantCode=${merchantCode}&voucherTemplateCode=${voucherTemplateCode}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
        body: formData,
      }
    );

    return await fetchResponse.json();
  } catch (error) {
    return error;
  }
};
export const updateVoucher = async (body) => {
    try {
        const fetchResponse = await fetch(baseURL + "UpdateVoucherTemplate", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};


export const redeemVoucher = async (merchantCode ,customercode,vouherCode) => {
    try {
        const fetchResponse = await fetch(baseURL + `RedeemVoucher?merchantCode=${merchantCode}&customercode=${customercode}&vouherCode=${vouherCode}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};
export const getWallet = async (merchantCode) => {
    try {
        const fetchResponse = await fetch(baseURL + `GetMerchantWalletDetails/${merchantCode}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            },
            
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

